<template>
  <div v-if="result">
    <div class="tile is-parent" style="max-width: 500px; margin: auto;">
      <article class="tile is-child box" style="">
        <div class="content">
          <div id="check" />
          <h2 style="text-align: center; margin-top: 0px;">Success!</h2>
          <p style="text-align: center;">You've successfully verified your business bank account!</p>
          <p style="text-align: center;">You can now close this page. Your representative will contact you if we need any additional information.</p>
        </div>
      </article>
    </div>
  </div>
  <div v-else>
    <h3>Oops!</h3>
    <p>Unfortunately we weren't able to verify your bank account. Please contact your representative for more information.</p>
  </div>
</template>

<script>
import Input from '@/components/shared/Input'
import $ from 'jquery'
export default {
  name: 'VerifyFinish',
  components: {
  },
  props: {
    result: Boolean
  },
  data () {
    return {
    }
  },
  mounted: function () {
    if (!this.result) {
      return
    }

    var animation = lottie.loadAnimation({
      container: document.getElementById('check'), // the dom element that will contain the animation
      renderer: 'svg',
      loop: false,
      autoplay: false,
      path: '../animations/check.json' // the path to the animation json
    });
    setTimeout(function() {
      animation.play()
    }, 500)

    for (var i = 0; i < 80; i++) {
      create(i)
    }

    function create (i) {
      var width = Math.random() * 20
      var height = width * 0.4
      var colour = 'green'

      $('<div class="confetti-' + i + ' ' + colour + '"></div>').css({
        'width': width + 'px',
        'height': height + 'px',
        'top': -Math.random() * 20 + '%',
        'left': Math.random() * 100 + '%',
        'opacity': Math.random() + 0.5,
        'transform': 'rotate(' + Math.random() * 360 + 'deg)'
      }).appendTo('#app')
      drop(i)
    }

    function drop (x) {
      $('.confetti-' + x).animate({
        top: '100%',
        left: '+=' + Math.random() * 15 + '%'
      }, Math.random() * 3000 + 2000, function () {
        $('.confetti-' + x).remove()
      })
    }
  },
  methods: {
    next () {
      this.$emit('next', this.$data)
      console.log(this.$data)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
[class|="confetti"] {
  position: absolute;
}

.green {
  background-color: #3cb968;
}

.level {
  margin-bottom: 10px !important;
}

#check {
  max-width: 20%;
  margin: auto;
  display: block;
}
</style>
